import { MutationTree } from 'vuex'

import type { SharedFolderState, SharedFolder } from './sharedFolders.types'

export enum MutationTypes {
  SET_LOADING = 'SET_LOADING',
  SET_ERROR_STATE = 'SET_ERROR_STATE',
  SET_SHARED_FOLDERS_STATE = 'SET_SHARED_FOLDERS_STATE',
  ADD_SHARED_FOLDER_STATE = 'ADD_SHARED_FOLDER_STATE'
}

export const mutations: MutationTree<SharedFolderState> = {
  [MutationTypes.SET_LOADING](state, loadingState: boolean) {
    state.loading = loadingState
  },
  [MutationTypes.SET_ERROR_STATE](state, errorMessage: string) {
    state.errorMessage = errorMessage
  },
  [MutationTypes.SET_SHARED_FOLDERS_STATE](state, sharedFolders: Array<SharedFolder>) {
    state.sharedFolders = sharedFolders
  },
  [MutationTypes.ADD_SHARED_FOLDER_STATE](state, sharedFolder: SharedFolder) {
    if (state.sharedFolders) {
      state.sharedFolders = [...state.sharedFolders, sharedFolder]
    } else {
      state.sharedFolders = [sharedFolder]
    }
  },
  addTechpackRequest(state) {
    state.addingTechpack = true
  },
  addTechpackSuccess(state) {
    state.addingTechpack = false
  }
}
